// eslint-disable-next-line no-unused-vars
import React from 'react';
import { EnvelopeSimple } from '@phosphor-icons/react/dist/ssr/EnvelopeSimple';
import { COLORS } from '../../../styles/UISystem';

/**
 * IconEmail Component
 *
 * Email icon with different states (default, active, selected)
 */
export const IconEmail = ({ state = 'default', size = 28, color, ...props }) => {
  // Determine background color based on state
  const getBackgroundColor = () => {
    switch (state) {
      case 'active':
        return COLORS.LIGHT_GRAY;
      case 'selected':
        return COLORS.MEDIUM_DARK_GRAY;
      default:
        return 'transparent';
    }
  };

  // Use provided color or default to DARK_GRAY
  const iconColor = color || COLORS.DARK_GRAY;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        backgroundColor: getBackgroundColor(),
        ...props.style,
      }}
      {...props}
    >
      <EnvelopeSimple size={size} color={iconColor} weight="regular" />
    </div>
  );
};

/**
 * IconEmailExample Component
 *
 * Used for displaying IconEmail examples in the UI System
 */
export const IconEmailExample = () => {
  return (
    <div style={{ marginBottom: '40px' }}>
      <div
        style={{
          fontSize: '24px',
          fontWeight: 'bold',
          color: COLORS.DARK_GRAY,
          marginBottom: '32px',
          textAlign: 'center',
        }}
      >
        IconEmail
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: '16px',
          maxWidth: '500px',
          margin: '0 auto',
        }}
      >
        {/* Default state */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '8px', fontSize: '16px', color: COLORS.DARK_GRAY }}>
            default
          </div>
          <IconEmail state="default" />
        </div>

        {/* Active state */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '8px', fontSize: '16px', color: COLORS.DARK_GRAY }}>
            active
          </div>
          <IconEmail state="active" />
        </div>

        {/* Selected state */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '8px', fontSize: '16px', color: COLORS.DARK_GRAY }}>
            selected
          </div>
          <IconEmail state="selected" />
        </div>
      </div>
    </div>
  );
};

export default IconEmail;
